import moment from 'moment';

const numberYearToDate = (year) => {
  return moment(new Date(String(year))).utc().format('MM-DD-YYYY')
}

export default numberYearToDate;
